<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <circle cx="8" cy="21" r="1" />
    <circle cx="19" cy="21" r="1" />
    <path d="M2.05 2.05h2l2.66 12.45a2 2 0 0 0 2 1.6h9.72a2 2 0 0 0 2-1.6l1.38-7.6H6.12" />
  </svg>
</template>

<script>
export default {
  name: 'IconShoppingCart',
  props: { className: { type: String, default: 'w-5 h-5' } },
}
</script>

